import { Plugin } from 'prosemirror-state';

import { AddMenuEquation, Equation } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.math_display.title') as string,
            icon: Equation,
            addMenuIcon: AddMenuEquation,
            addMenuItemType: addMenuItemType.advanced_blocks,
            description: t('Lygo:Menu.math_display.description') as string,
            searchWords: ['math', 'math display', 'equations'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
